import { useMessagingStore } from './../../messaging/hooks/use-messaging-store';

export function useActiveConversationsUnreadInfo(): {
    unreadCount: number;
    hasUrgentUnread: boolean;
} {
    const { activeConversationsUnreadInfo } = useMessagingStore();

    const { unreadCount = 0, hasUrgentUnread = false } = activeConversationsUnreadInfo ?? {};

    return { unreadCount, hasUrgentUnread };
}
